export default __webpack_public_path__ + "static/media/1628.70760bf5.png";